import React from 'react';
import ListSubheader from '@mui/joy/ListSubheader';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemContent from '@mui/joy/ListItemContent';
import List from '@mui/joy/List';
import {Stack} from "@mui/joy";
import Link from "@mui/joy/Link";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";

// components
import withNavigate from '../../utils/withNavigate';
import {closeSidebar} from "./utils";


class CommonSidebarLink extends React.Component {

    render() {
        if (!this.props.item.type) {
            return(
                <ListItem>
                    <ListItemButton
                        onClick={() => {
                            this.props.navigate(this.props.item.link)
                            closeSidebar()
                        }}
                        color={this.props.location.pathname.split('/').slice(1).join('/').startsWith(this.props.item.link?.slice(1))?'primary':null}
                        variant={this.props.location.pathname.split('/').slice(1).join('/').startsWith(this.props.item.link?.slice(1))?'soft':null}
                    >
                        <this.props.item.icon
                            fontSize={'small'}
                        />
                        <ListItemContent
                            sx={{
                                'pl': 1,
                            }}

                        >
                            <Typography
                                level={'body-sm'}
                            >
                                {this.props.item.title}
                            </Typography>
                        </ListItemContent>
                    </ListItemButton>
                </ListItem>
            )
        }
        switch (this.props.item.type){
            case 'link':
                return(
                    <ListItem>
                        <ListItemButton>
                            <Link
                                href={this.props.item.link}
                                target={'_blank'}
                                color="inherit"
                                underline="none"
                            >
                                <this.props.item.icon
                                    fontSize={'small'}
                                />
                                <ListItemContent
                                    sx={{
                                        'pl': 1,
                                    }}
                                >
                                    <Typography
                                        level={'body-sm'}
                                    >
                                        {this.props.item.title}
                                    </Typography>
                                </ListItemContent>
                            </Link>
                        </ListItemButton>
                    </ListItem>
                )
            case 'component':
                return (
                    <ListItem>
                        {this.props.item.component}
                    </ListItem>
                )
            default:
                return (<></>)
        }
    }
}


class CommonSidebar extends React.Component {
    render() {
        return (
            <Stack
                sx={
                        {
                            overflowY: 'scroll',
                        }
                    }
            >
                {
                    this.props.groups.filter((group) => (!group.hide)).map((group) => (
                        <List
                            key={group.title}
                        >
                            <ListSubheader
                                role='presentation'
                                sx={{color: 'text.primary'}}
                            >
                                {group.title}
                            </ListSubheader>
                            {
                                group.items.filter((item) => (!item.hide)).map(
                                    (item, index) => {
                                        return (
                                            <Box
                                                key={index}
                                            >
                                                {
                                                    <CommonSidebarLink
                                                        item={item}
                                                        navigate={this.props.navigate}
                                                        location={this.props.location}
                                                    />
                                                }
                                            </Box>
                                        )
                                    }
                                )
                            }
                        </List>
                    ))
                }
            </Stack>
        )
    }
}

export default withNavigate(CommonSidebar);
